import { useState, forwardRef, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
import Stack from '@mui/joy/Stack';
import { styled } from '@mui/joy/styles';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Input from '@mui/joy/Input';
// import Link from "@mui/material/Link";
import Button from '@mui/joy/Button';

import EmailIcon from '../../../assets/icons/EmailIcon.svg'
import PasswrodIcon from '../../../assets/icons/passwordIcon.svg'



//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


////////////////// API
import { login } from '../../../Api/Auth';



const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



const schema = yup.object({
    email: yup.string().required("البريد الالكتروني مطلوب"),
    password: yup.string().required("الرقم السري مطلوب"),

})


export default function FormLoginComponent() {
    const navigate = useNavigate()


    const [loadingApi, setLoadingApi] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            email: "",
            password: ""
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClick = () => {
        setOpenAlert(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    }


    const submitLogin = async (data) => {
        setLoadingApi(true)
        try {
            const res = await login(data)
            if (res.data) {
                localStorage.setItem("adminRoleSoomha", JSON.stringify(res.data.data.user.roles));
                localStorage.setItem("typeAdminSoomha", JSON.stringify(res.data.data.user.type));
                setLoadingApi(false)
                navigate('/')
                window.location.reload(true);
            }
        } catch (error) {
            if (error.response) {
                setLoadingApi(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }

    };


    return (
        <>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="warning">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>

            <Box sx={{
                width: '80%',
                backgroundColor: '#FFF',
                borderRadius: '30px',
                border: '1px solid #60A5DC',
                margin: 'auto',
                marginTop: '40px',
                padding: '70px 0'
            }}
            >
                <Typography level="h3" sx={{ textAlign: 'center' }}>تسجيل دخول</Typography>
                <form onSubmit={handleSubmit(submitLogin)}>

                    <Stack spacing={2} sx={{ width: '80%', margin: 'auto', marginTop: '100px' }}>
                        <FormControl>
                            <FormLabel sx={{ fontSize: '16px', color: '#434448', fontWeight: 'bold' }}>البريد الالكتروني</FormLabel>
                            <Input
                                type='email'
                                placeholder="ادخل البريد الالكتروني"
                                startDecorator={<img src={EmailIcon}
                                    alt='email icon' />}
                                sx={{ height: '60px', borderRadius: '30px' }}
                                {...register('email')}
                            />

                        </FormControl>
                        {errors.email &&
                            <Typography
                                color="danger"
                                level="body-xs"
                                variant="plain"
                            >{errors.email?.message}</Typography>
                        }
                        <FormControl>
                            <FormLabel sx={{ fontSize: '16px', color: '#434448', fontWeight: 'bold' }}>كلمة المرور</FormLabel>
                            <Input
                                type='password'
                                placeholder="****************"
                                startDecorator={<img src={PasswrodIcon}
                                    alt='email icon' />}
                                sx={{ height: '60px', borderRadius: '30px' }}
                                {...register('password')}
                            />
                        </FormControl>
                        {errors.password &&
                            <Typography
                                color="danger"
                                level="body-xs"
                                variant="plain"
                            >{errors.password?.message}</Typography>
                        }
                        <Link to="forget-password"
                            className='linkNavigate'
                        >
                            {"هل نسيت كلمة المرور ؟"}
                        </Link>
                        <Button
                            type='submit'
                            loading={loadingApi}
                            sx={{ height: '60px', backgroundColor: '#3E64F4', color: '#FFF', fontSize: '20px', borderRadius: '30px' }}
                        >تسجيل دخول</Button>
                    </Stack>
                </form>
            </Box>
        </>

    )
}